import React, { useEffect, useRef, useState } from 'react';
import { App, Button, Form } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import SinglePageContainer from '../../Common/SinglePageContainer';
import PageSection from '../../Common/SinglePageContainer/PageSection';
import { ReferralTemplatesFormProps } from './types';
import {
  SettingsItemProps,
  useSettingsItemCreate,
  useSettingsItemGetByKey,
  useSettingsItemUpdate,
} from '../../../hooks/api/settings';
import { useMessageError } from '../../../hooks/common';
import { useSimpleModal } from '../../Common/Modal/Simple';
import { FetchSuccess } from '../../../hooks/fetch';
import WhatsAppTemplate from './WhatsAppTemplate';
import EmailTemplate from './EmailTemplate';

const initialState: ReferralTemplatesFormProps = {
  whatsAppTemplate: '',
  emailTemplate: '',
};

const pageKey = 'referralTemplates';

export default function ReferralTemplates(): React.ReactNode {
  const { message } = App.useApp();
  const { open, contextHolder } = useSimpleModal();
  const [form] = Form.useForm<ReferralTemplatesFormProps>();

  const isSettingsExist = useRef(false);

  const settingsItemGetByKey = useSettingsItemGetByKey<ReferralTemplatesFormProps>();
  const settingsItemCreate = useSettingsItemCreate<ReferralTemplatesFormProps>();
  const settingsItemUpdate = useSettingsItemUpdate();
  // const settingsItemDelete = useSettingsItemDelete(pageKey);

  /** Initial Values >>> */
  const [initialValues, setInitialValues] = useState(initialState);

  useEffect(() => {
    settingsItemGetByKey.fetch(undefined, pageKey)
      .then((res) => {
        if (res?.key) {
          isSettingsExist.current = true;
          setInitialValues({ ...initialState, ...res.value });
        }
      });
  }, []);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(initialValues);
  }, [initialValues]);
  /** <<< Initial Values */

  const handleSubmit = (values: ReferralTemplatesFormProps) => {
    const payload: SettingsItemProps<ReferralTemplatesFormProps> = { key: pageKey, value: values, expiration: null };

    // eslint-disable-next-line unicorn/consistent-function-scoping
    const thenFunc = (res?: FetchSuccess | null, callback?: () => void) => {
      if (res?.success) {
        callback?.();
        message.success('Settings successfully updated!');
      }
    };

    /** If we did not found item by key in API - means there's no item with such key, so we create it */
    if (!isSettingsExist.current) {
      settingsItemCreate.fetch(payload)
        .then((res) => thenFunc(res, () => { isSettingsExist.current = true; }));
    } else {
      /** On update, we send one of array items, and backend updates each object by 'key' */
      settingsItemUpdate.fetch([payload])
        .then(thenFunc);
    }
  };

  useMessageError([settingsItemGetByKey, settingsItemCreate, settingsItemUpdate]);

  // const handleDelete = () => {
  //   open({
  //     icon: <ExclamationCircleFilled />,
  //     title: 'Reset',
  //     content: 'Are you sure you want to reset all referral templates settings?',
  //     okText: 'Reset',
  //     maskClosable: true,
  //     okButtonProps: {
  //       danger: true,
  //     },
  //     onOk: () => settingsItemDelete.fetch()
  //       .then((res) => {
  //         if (res?.success) {
  //           message.success('Custom settings for this section successfully deleted');
  //           setInitialValues(initialState);
  //           form.resetFields();
  //           settingsItemGetByKey.clearResponse();
  //           isSettingsExist.current = false;
  //         }
  //       }),
  //   });
  // };

  return (
    <SinglePageContainer
      title="Referral Templates Settings"
      breadcrumbItems={[]}
      stickyHeader
      cardLoading={settingsItemGetByKey.loading}
      extra={(
        <>
          {/* {isSettingsExist.current ? (
            <Button
              danger
              onClick={handleDelete}
              loading={settingsItemDelete.loading || settingsItemCreate.loading}
            >
              Reset
            </Button>
          ) : null} */}
          <Button
            onClick={form.submit}
            icon={<SaveOutlined />}
            loading={settingsItemCreate.loading || settingsItemUpdate.loading}
          >
            Save
          </Button>
        </>
      )}
    >
      {contextHolder}
      <Form
        form={form}
        name="referralTemplates"
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={initialValues}
      >
        <PageSection title="WhatsApp Template" dividerStyle={{ marginTop: 0 }}>
          <WhatsAppTemplate />
        </PageSection>

        <br />

        <PageSection title="Email Template">
          <EmailTemplate />
        </PageSection>
      </Form>
    </SinglePageContainer>
  );
}
